module.exports = __webpack_public_path__ + "static/media/future.dd5b7667.svg";